import moment from 'moment';

import { Base } from './_base.model';

export class Topic extends Base {
  id: number;
  name: string;
  display_name: string;
  version: string;
  info: string;
  duplicate_key: string;
  description: string;
  topic_type_id: string;
  archived: boolean;
  topic_id: string;
  approval_date: Date;
  valid_from: Date;
  valid_to: Date;
  bureau_id: string;
  requestable: boolean;
  untrained_requestable: boolean;
  parent_id: string;
  created_at: Date;

  topic_type: any;
  meeting_types: any[];
  products: any[];
  sub_topics: any[];
  requires_training_ids: number[];
  requires_topic_ids: number[];
  objectives: string[];

  full_name: string;

  constructor() {
    super();
    this.requestable = true;
  }

  deserialize(obj: any) {
    Object.assign(this, obj);
    if (this.valid_from) {
      this.valid_from = moment(this.valid_from).toDate();
    }
    if (this.valid_to) {
      this.valid_to = moment(this.valid_to).toDate();
    }
    return this;
  }
}
